import { useEffect } from 'react'

import { getWebsiteName } from '~/utils/env'

const useDocumentTitle = (title: string): void => {
  useEffect(() => {
    document.title = `${getWebsiteName()} | ${title}`
  }, [title])
}

export default useDocumentTitle
